import { useEffect } from 'react';

/**
 * Custom hook to manage page titles
 * @param title - The page title to set
 * @param suffix - Optional suffix to append (defaults to " | Eventi Vendor")
 */
export const usePageTitle = (title: string, suffix: string = ' | Eventi Vendor') => {
  useEffect(() => {
    const fullTitle = title ? `${title}${suffix}` : 'Eventi Vendor';
    document.title = fullTitle;
    
    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = 'Eventi Vendor';
    };
  }, [title, suffix]);
};

export default usePageTitle;
